import { render, staticRenderFns } from "./tabsMenu.vue?vue&type=template&id=558dabaa&scoped=true"
import script from "./tabsMenu.vue?vue&type=script&lang=js"
export * from "./tabsMenu.vue?vue&type=script&lang=js"
import style0 from "./tabsMenu.vue?vue&type=style&index=0&id=558dabaa&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "558dabaa",
  null
  
)

export default component.exports